var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fades" } }, [
    _c(
      "div",
      {
        staticClass: "no-network",
        staticStyle: { "z-index": "10000" },
        on: {
          mousewheel: function($event) {
            $event.preventDefault()
          },
          scroll: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
          }
        }
      },
      [
        _c("div", { staticClass: "NoNetwork_box" }, [
          _c("div", { staticClass: "NoNetwork_box_img img_reset" }, [
            _c("img", {
              attrs: { src: require("../../../assets/img/NoNetwork.png") }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "NoNetwork_box_title bold" }, [
            _vm._v("你的网络异常，请检查后重试")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "NoNetwork_box_text" }, [
            _vm._v("很抱歉！暂时无法使用，请稍后再试")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "NoNetwork_box_btn cursor", on: { click: _vm.btn } },
            [_vm._v("点击刷新")]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1ddc7b99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1ddc7b99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/NoNetwork/src/main.vue
// module id = null
// module chunks = 